var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.996 2.085C.608 2.24.968 3.691 1.32 4.398c3.599 7.323 11.16 22.47 12.624 24.475 1.465 2.005 2.859.835 3.373 0L31 2.085h-1.735l-10.31 20.043h-2.602L6.043 2.085c-.771-.064-2.66-.154-4.047 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtho);
export default __webpack_public_path__ + "static/media/VTHO.cd5c60d176f398cd1179bbc2d2d23b6d.svg";
export { ForwardRef as ReactComponent };